import React from "react"
import { Box } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"

import { dsColorNew } from "@palette"


// Full-width white band under the shell header, from the Dataseekers retail front: the toggles on
// top (left / right groups), then the fields, with the actions at the bottom right.
// The negative margins cancel the page padding (40px sides, 16px under the header).
const bandSx = {
	backgroundColor: dsColorNew.white,
	borderBottom: `1px solid ${dsColorNew.grayBorder}`,
	mx: -5,
	px: 5,
}

// Fields share one height and the light input background; four per row unless the page asks otherwise.
export const filterPanelGridSx = (columns = 4) => ({
	display: 'grid',
	gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`,
	gap: '18px 16px',
	alignItems: 'start',
	'& > .MuiGrid-item': { maxWidth: 'none', flexBasis: 'auto', p: 0 },
})

export default function AppFilterPanel({ toggles, togglesRight, actions, children, sx = {} }) {
	const hasToggles = !!toggles || !!togglesRight

	return <Box sx={{ mt: -2, mb: 3, ...sx }}>
		<Box sx={{
			...bandSx,
			pt: hasToggles ? 2 : 3,
			pb: 2.5,
			'& .MuiOutlinedInput-root': { minHeight: 40, backgroundColor: dsColorNew.filterInputBg },
			'& .MuiInputLabel-shrink': { backgroundColor: dsColorNew.white, px: 0.5, ml: -0.5 },
			'& .rs-picker-toggle': { minHeight: 40, backgroundColor: `${dsColorNew.filterInputBg} !important` },
			'& .rs-picker-toggle-wrapper': { backgroundColor: dsColorNew.filterInputBg },
			// Selected values (dates, lengths, sites…) as the soft blue chips of the table filters
			'& .MuiOutlinedInput-root .MuiChip-root': {
				backgroundColor: dsColorNew.pillActiveBg, color: dsColorNew.appBlue, fontWeight: 500,
				'& .MuiChip-deleteIcon': { color: dsColorNew.appBlue, opacity: 0.7, '&:hover': { color: dsColorNew.appBlue, opacity: 1 } },
			},
		}}>
			{hasToggles && <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2, flexWrap: 'wrap', mb: (children || actions) ? 3 : 0 }}>
				<Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>{toggles}</Box>
				<Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>{togglesRight}</Box>
			</Box>}
			{children}
			{!!actions && <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 1.5, mt: 2.5 }}>
				{actions}
			</Box>}
		</Box>
	</Box>
}

// The Search button at the foot of every filter panel: app blue, 40px, with the magnifier.
export const filterSearchButtonProps = {
	sx: {
		px: 2.5, height: 40, borderRadius: '10px', boxShadow: 'none', '& .MuiButton-startIcon > *': { fontSize: 14 },
		backgroundColor: dsColorNew.appBlue, '&:hover': { backgroundColor: dsColorNew.appBlueHover, boxShadow: 'none' },
	},
	startIcon: <IconSeeker icon="magnifying-glass" sx={{ fontSize: 14 }}/>,
}
